<template>
<div class="chapter">
<div class="inner_page">
<div><a id="c3"></a></div>
<div class="xpage">
<h4 class="chaptitle"><a href="#/html/003_toc#c3_">ON AFGHANISTAN</a></h4>
<p class="textfirst">I have always thought that we did the right thing in Afghanistan. My only concern with respect to Afghanistan was that we diverted our attention from Afghanistan in terms of
    moving into Iraq, and I think would could have done a better job of stabilizing that country than we have in providing assistance to the Afghani people. All of us should be rooting for the
    Afghani people and making sure that we are providing them the support to make things happen.</p>
<p class="right2">Illinois Senate Debate, Illinois Radio Network, October 12, 2004</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 009_chap3.vue?2ea0e218